// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ...existing code... */

@media print {
  .no-print {
    display: none;
  }
  .new-page {
    page-break-before: always;
  }
}

.checkbox-container {
  flex-direction: wrap;
  margin-top: 10px;
  position: center;
  text-align: left; /* Add this line to left-align the text */
}

.checkbox-container label {
  margin-bottom: 5px;
  align-items: center;
}

.checkbox-container input {
  margin-right: 10px;
}

.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-header .print-link {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/listen/wahlkreis/wahlkreis.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE;IACE,aAAa;EACf;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB,EAAE,yCAAyC;AAC7D;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB","sourcesContent":["/* ...existing code... */\n\n@media print {\n  .no-print {\n    display: none;\n  }\n  .new-page {\n    page-break-before: always;\n  }\n}\n\n.checkbox-container {\n  flex-direction: wrap;\n  margin-top: 10px;\n  position: center;\n  text-align: left; /* Add this line to left-align the text */\n}\n\n.checkbox-container label {\n  margin-bottom: 5px;\n  align-items: center;\n}\n\n.checkbox-container input {\n  margin-right: 10px;\n}\n\n.table-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.table-header .print-link {\n  margin-left: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
